var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":("animate__animated " + _vm.enter),"leave-active-class":("animate__animated " + _vm.exit)}},[(_vm.show)?_c('div',[_vm._t("default",[_vm._v(" "+_vm._s(_vm.message)+" ")])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }